import * as React from 'react';
import {Slider as SliderPrimitive} from 'radix-ui';
import {cn} from '@/lib/utils';

export function Slider({className,value,labels,...props}:React.ComponentProps<typeof SliderPrimitive.Root>&{labels:string[]}){
 return <SliderPrimitive.Root value={value} className={cn('relative flex w-full touch-none select-none items-center py-3',className)} {...props}>
  <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-secondary"><SliderPrimitive.Range className="absolute h-full bg-primary"/></SliderPrimitive.Track>
  {labels.map(label=><SliderPrimitive.Thumb key={label} aria-label={label} className="block size-4 rounded-full border border-primary bg-background shadow-sm outline-none focus-visible:ring-4 focus-visible:ring-ring/50"/>)}
 </SliderPrimitive.Root>;
}
